import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import i18n from '../../i18n';
import { dataShape } from '../../shapes/dataShape';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './LifeEngagement.scss';
import { CONSTANTS } from '../../constants';
import OneLineComparison from '../../components/OneLineComparison';

function LifeEngagement({ data }) {
	const { t } = useTranslation();
	const { key, color, pageNumber } = CONSTANTS.LIFE_ENGAGEMENT;

	return (
		<article className={`life-engagement ${i18n.language === 'fr-CA' && 'french'}`}>
			<section className="page">
				<Header title={t('pages:lifeEngagement.title')} color={color} />
				<div className="report-content">
					<OneLineComparison data={data} section={key} />
					<div className="overview">
						<h3>{t('common:overview')}</h3>
						<p>
							{t('pages:lifeEngagement.lifeEngagementWasMeasured')}
						</p>
						<p>
							{t('pages:lifeEngagement.researchByPressman')}
						</p>
					</div>
				</div>
				<div className="bottom">
					<div className="row">
						<div className="col-half">
							<h3>{t('pages:lifeEngagement.checkingInAndLifeEngagement')}</h3>
							<p>
								{t('pages:lifeEngagement.checkingInEncouragesYou')}
							</p>
							<p>
								{t('pages:lifeEngagement.ifYouFindThatYourFrequency')}
							</p>
						</div>
						<div className="col-half reflection">
							<h3>{t('common:reflection')}</h3>
							<p>
								{t('pages:lifeEngagement.takeAMomentToConsider')}
							</p>
							<p>{t('pages:lifeEngagement.goingForward')}</p>
						</div>
					</div>
				</div>
				<Footer pageNumber={pageNumber} />
			</section>
		</article>
	);
}

LifeEngagement.propTypes = {
	data: dataShape.isRequired,
};

export default LifeEngagement;
